import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-10"
}
const _hoisted_2 = { class: "rounded-xl bg-white border border-gray-200" }
const _hoisted_3 = { class: "min-w-full w-full preview-table" }
const _hoisted_4 = { class: "columns" }
const _hoisted_5 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "text-sm text-gray-900 font-medium py-6 pl-3" }
const _hoisted_36 = { class: "text-sm text-gray-600 py-6" }
const _hoisted_37 = { class: "text-sm text-gray-600 py-6" }
const _hoisted_38 = { class: "text-sm text-gray-600 py-6" }
const _hoisted_39 = { class: "text-sm text-gray-600 py-6" }
const _hoisted_40 = { class: "text-sm text-gray-600 py-6" }
const _hoisted_41 = {
  key: 1,
  class: "mt-14"
}
const _hoisted_42 = { class: "rounded-xl bg-white border border-gray-200" }
const _hoisted_43 = { class: "text-2xl text-gray-900 font-semibold px-3 py-6 border-b border-b-2 border-gray-200" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_45 = { class: "min-w-full w-full upload-preview-table border-b border-gray-900 border-collapse mt-4" }
const _hoisted_46 = { class: "columns" }
const _hoisted_47 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { key: 0 }
const _hoisted_66 = { key: 1 }
const _hoisted_67 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { key: 1 }
const _hoisted_72 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { key: 0 }
const _hoisted_76 = { key: 1 }
const _hoisted_77 = { class: "text-sm text-gray-900 font-medium py-6 pl-6" }
const _hoisted_78 = { class: "text-sm text-gray-600 py-6" }
const _hoisted_79 = { class: "text-sm text-gray-600 py-6" }
const _hoisted_80 = { class: "text-sm text-gray-600 py-6" }
const _hoisted_81 = { class: "text-sm text-gray-600 py-6" }
const _hoisted_82 = { class: "text-sm text-gray-600 py-6" }

import { ref } from 'vue';
import { useFilterStore } from "@/stores/filterStore";
import { Learner } from "@/interfaces/learner.interface";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchAndloadComponent',
  props: {
    uploadPreviewCard: {
        type: Boolean,
        required: true,
    },
    archivemethodSelected: {
        type: String,
        required: true,
    },
    actionType: {
        type: String,
        required: true,
    },
    uploadedLearners: {
        type: Array as () => Learner[],
        required: true,
    },
    searchLoadPreviewCard: {
        type: Boolean,
        required: true,
    },
    selectedLearnersData: {
        type: Array as () => Learner[],
        required: true,
    },
    
},
  setup(__props) {

const props = __props;

const filterStore = useFilterStore();



const sortKey3 = ref('');
const sortOrder3 = ref('asc'); 
const sortKey2 = ref('');
const sortOrder2 = ref('asc');

const sortTable3 = (key: string) => {
  if (sortKey3.value === key) {
    sortOrder3.value = sortOrder3.value === 'asc' ? 'desc' : 'asc';
  } else {
    sortKey3.value = key;
    sortOrder3.value = 'asc';
  }

  props.selectedLearnersData.map((a: any, b: any) => {
    let result = 0;
    if (key === 'class') {
      const aClass = a.classes.find((cls:any) => cls.subject._id == filterStore.selectedFilters.subject)?.name || '';
      const bClass = b.classes.find((cls:any) => cls.subject._id == filterStore.selectedFilters.subject)?.name || '';
      if (aClass < bClass) {
        result = -1;
      } else if (aClass > bClass) {
        result = 1;
      }
    } else {
      if (a[key] < b[key]) {
        result = -1;
      } else if (a[key] > b[key]) {
        result = 1;
      }
    }
    return sortOrder3.value === 'asc' ? result : -result;
  });
};

const sortTable2 = (key: string) => {
  if (sortKey2.value === key) {
    sortOrder2.value = sortOrder2.value === 'asc' ? 'desc' : 'asc';
  } else {
    sortKey2.value = key;
    sortOrder2.value = 'asc';
  }

  props.selectedLearnersData.map((a: any, b: any) => {
    let result = 0;
    if (key === 'class') {
      const aClass = a.classes.find((cls: any) => cls.subject._id == filterStore.selectedFilters.subject)?.name || '';
      const bClass = b.classes.find((cls: any) => cls.subject._id == filterStore.selectedFilters.subject)?.name || '';
      if (aClass < bClass) {
        result = -1;
      } else if (aClass > bClass) {
        result = 1;
      }
    } else {
      if (a[key] < b[key]) {
        result = -1;
      } else if (a[key] > b[key]) {
        result = 1;
      }
    }
    return sortOrder2.value === 'asc' ? result : -result;
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.searchLoadPreviewCard && props.archivemethodSelected === '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("table", _hoisted_3, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_4, [
                  _createElementVNode("th", {
                    class: "text-start text-gray-600 font-medium text-xs py-3 pl-3",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (sortTable2('firstName')))
                  }, [
                    _createElementVNode("span", _hoisted_5, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.first_name")), 1),
                      _hoisted_6,
                      (sortKey2.value === 'firstName'|| sortKey2.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                            (sortOrder2.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_9, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "text-start text-gray-600 font-medium text-xs py-3",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (sortTable2('lastName')))
                  }, [
                    _createElementVNode("span", _hoisted_10, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.last_name")), 1),
                      _hoisted_11,
                      (sortKey2.value === 'lastName'|| sortKey2.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                            (sortOrder2.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_14, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "text-start text-gray-600 font-medium text-xs py-3",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (sortTable2('grade')))
                  }, [
                    _createElementVNode("span", _hoisted_15, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.grade")), 1),
                      _hoisted_16,
                      (sortKey2.value === 'grade'|| sortKey2.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                            (sortOrder2.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_19, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "text-start text-gray-600 font-medium text-xs py-3",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (sortTable2('email')))
                  }, [
                    _createElementVNode("span", _hoisted_20, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.email")), 1),
                      _hoisted_21,
                      (sortKey2.value === 'email'|| sortKey2.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                            (sortOrder2.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_23, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_24, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "text-start text-gray-600 font-medium text-xs py-3",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (sortTable2('class')))
                  }, [
                    _createElementVNode("span", _hoisted_25, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.class")), 1),
                      _hoisted_26,
                      (sortKey2.value === 'class'|| sortKey2.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                            (sortOrder2.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_29, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "text-start text-gray-600 font-medium text-xs py-3",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (sortTable2('status')))
                  }, [
                    _createElementVNode("span", _hoisted_30, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.status")), 1),
                      _hoisted_31,
                      (sortKey2.value === 'status'|| sortKey2.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                            (sortOrder2.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_33, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_34, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.selectedLearnersData, (learner) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: learner._id,
                    class: "mb-1"
                  }, [
                    _createElementVNode("td", _hoisted_35, _toDisplayString(learner.firstName), 1),
                    _createElementVNode("td", _hoisted_36, _toDisplayString(learner.lastName), 1),
                    _createElementVNode("td", _hoisted_37, _toDisplayString(learner.grade), 1),
                    _createElementVNode("td", _hoisted_38, _toDisplayString(learner.email), 1),
                    _createElementVNode("td", _hoisted_39, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((learner.classes || []).filter((cls) => cls.subject._id == _unref(filterStore).selectedFilters.subject), (classItem) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "rounded-[50px] py-1 px-2 mr-1 shadow-none outline-none text-xs bg-blue-600 text-white",
                          key: classItem._id
                        }, _toDisplayString(classItem.name), 1))
                      }), 128))
                    ]),
                    _createElementVNode("td", _hoisted_40, [
                      _createElementVNode("strong", null, _toDisplayString(learner.status), 1)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (props.uploadPreviewCard && props.archivemethodSelected === '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("h2", _hoisted_43, _toDisplayString(props.actionType === 'archived' ? _ctx.$t("archive_flow.archive_btn") : _ctx.$t("archive_flow.unarchive_btn")) + " " + _toDisplayString(_ctx.$t("archive_flow.upload_preview_header")), 1),
            _hoisted_44,
            _createElementVNode("table", _hoisted_45, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_46, [
                  _createElementVNode("th", {
                    class: "text-start text-xs text-gray-600 font-medium py-3 pl-3",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (sortTable3('firstName')))
                  }, [
                    _createElementVNode("span", _hoisted_47, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.name")), 1),
                      _hoisted_48,
                      (sortKey3.value === 'firstName'|| sortKey3.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_49, [
                            (sortOrder3.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_50, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_51, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "text-start text-xs text-gray-600 font-medium py-3",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (sortTable3('lastName')))
                  }, [
                    _createElementVNode("span", _hoisted_52, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.last_name")), 1),
                      _hoisted_53,
                      (sortKey3.value === 'lastName'|| sortKey3.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_54, [
                            (sortOrder3.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_55, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_56, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "text-start text-xs text-gray-600 font-medium py-3",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (sortTable3('school')))
                  }, [
                    _createElementVNode("span", _hoisted_57, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.school")), 1),
                      _hoisted_58,
                      (sortKey3.value === 'school'|| sortKey3.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_59, [
                            (sortOrder3.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_60, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_61, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "text-start text-xs text-gray-600 font-medium py-3",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (sortTable3('grade')))
                  }, [
                    _createElementVNode("span", _hoisted_62, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.grade")), 1),
                      _hoisted_63,
                      (sortKey3.value === 'grade'|| sortKey3.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_64, [
                            (sortOrder3.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_65, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_66, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "text-start text-xs text-gray-600 font-medium py-3",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (sortTable3('email')))
                  }, [
                    _createElementVNode("span", _hoisted_67, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.email")), 1),
                      _hoisted_68,
                      (sortKey3.value === 'email'|| sortKey3.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_69, [
                            (sortOrder3.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_70, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_71, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "text-start text-xs text-gray-600 font-medium py-3",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (sortTable3('class')))
                  }, [
                    _createElementVNode("span", _hoisted_72, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.class")), 1),
                      _hoisted_73,
                      (sortKey3.value === 'class'|| sortKey3.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_74, [
                            (sortOrder3.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_75, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_76, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.uploadedLearners, (learner, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: "mb-1 border-b border-light-blue-gray"
                  }, [
                    _createElementVNode("td", _hoisted_77, _toDisplayString(learner.firstName), 1),
                    _createElementVNode("td", _hoisted_78, _toDisplayString(learner.lastName), 1),
                    _createElementVNode("td", _hoisted_79, _toDisplayString(learner.school), 1),
                    _createElementVNode("td", _hoisted_80, _toDisplayString(learner.grade), 1),
                    _createElementVNode("td", _hoisted_81, _toDisplayString(learner.email), 1),
                    _createElementVNode("td", _hoisted_82, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((learner.classes || []).filter((cls) => cls.subject._id == _unref(filterStore).selectedFilters.subject), (classItem) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "rounded-[50px] py-1 px-2 mr-1 shadow-none outline-none text-xs bg-blue-600 text-white",
                          key: classItem._id
                        }, _toDisplayString(classItem.name), 1))
                      }), 128))
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})